// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".d2-demo-article[data-v-1b29c347] {\n  -webkit-transition: opacity 0.3s;\n  transition: opacity 0.3s;\n}\n.d2-demo-article .d2-demo-article__control[data-v-1b29c347] {\n  padding: 8px 16px;\n  margin-bottom: 10px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 4px;\n  background-color: #f4f4f5;\n}", ""]);
// Exports
module.exports = exports;
